import { useEffect } from 'react';
import { supabase } from '../lib/supabase';

// Generate or retrieve visitor ID from localStorage
const getVisitorId = (): string => {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    visitorId = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
};

export function useVisitorTracking() {
  useEffect(() => {
    const logVisit = async () => {
      // Check if supabase client is available
      if (!supabase) {
        console.log('Supabase client not initialized, skipping visitor tracking');
        return;
      }

      try {
        const visitorId = getVisitorId();
        
        // Get current user if authenticated
        const { data: { user } } = await supabase.auth.getUser();
        
        // Get user agent
        const userAgent = navigator.userAgent;

        // Call edge function to log visit
        const { data, error } = await supabase.functions.invoke('log-visit', {
          body: {
            visitorId,
            email: user?.email || null,
            userAgent,
            ipAddress: null, // IP will be captured server-side if needed
          },
        });

        if (error) {
          console.error('Error logging visit:', error);
        } else {
          console.log('Visit logged successfully');
        }
      } catch (error) {
        console.error('Error in visitor tracking:', error);
      }
    };

    logVisit();
  }, []);
}
